import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

import "./Command.css";

// Custom hook to handle keyboard shortcuts
function useKeyboardShortcut(shortcut, action) {
  useEffect(() => {
    const keys = shortcut.split("+").map((key) => key.trim().toLowerCase()); // Split by '+' and normalize keys

    function onKeyup(e) {
      e.preventDefault();
      // Check if all keys in the shortcut are pressed
      const keyPressed = e.key.toLowerCase();
      const ctrlPressed = e.ctrlKey || keys.includes("ctrl");
      const altPressed = e.altKey || keys.includes("alt");
      const shiftPressed = e.shiftKey || keys.includes("shift");
      const metaPressed =
        e.metaKey || keys.includes("cmd") || keys.includes("command");

      if (
        keys.includes(keyPressed) &&
        (!ctrlPressed || e.ctrlKey) &&
        (!altPressed || e.altKey) &&
        (!shiftPressed || e.shiftKey) &&
        (!metaPressed || e.metaKey)
      ) {
        action();
      }
    }

    if (shortcut) {
      window.addEventListener("keyup", onKeyup);
      return () => window.removeEventListener("keyup", onKeyup);
    }
    return () => {};
  }, [shortcut, action]);
}

export const Command = ({
  to = "",
  onActivated,
  disabled,
  command,
  hidden = false,
}) => {
  const history = useHistory();

  useKeyboardShortcut(command, () => {
    if (disabled) return;
    if (to) history.push(to);
    if (onActivated) onActivated();
  });

  return (
    <span hidden={hidden} className="command">
      {command}
    </span>
  );
};
